import React, { useState, useEffect, Fragment } from 'react'; 
import { ImageGallery } from "react-image-grid-gallery"; 
import {API_BASE_URL} from '../../../../config';
import axios from "axios";

const Articles = () => { 

    const [posts, setPosts] = useState({});    
    const [gallery, setGallery] = useState([]);  

    useEffect(() => {     
        try {
            axios.get(API_BASE_URL + "/api/posts").then(function (response) { 
                let data = JSON.parse(JSON.stringify(response.data));
                data = data.data;
                if(data.post_categories.General != undefined) { 
                    let postArray = [];
                    let post_list = data.post_categories.General; 
                    post_list.forEach(post => {
                        postArray.push({
                            id: post.post_id,
                            alt: post.post_title,
                            caption: post.post_title,
                            src: post.post_image
                        });
                     });  
                    setGallery(postArray);
                    setPosts(data.post_categories);
                }
            }); 
        }
        catch (error) { 
            console.log(error);
        }
    }, []); 
  

    return (
        <section className='doc_features_area'> 
            <div className='container'> 
                <div className='row'> 
                    <div className='col-md-12'>   
                        <div className="card">
                            <div className="card-body" id="grid">                                                 
                            { gallery.length > 0 ? 
                                <ImageGallery 
                                    imagesInfoArray = {gallery} 
                                    columnCount = {"auto"}
                                    columnWidth = {360}
                                /> : "" } 
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
        </section>
    );
}


export default Articles;